export default __webpack_public_path__ + "static/media/thumbnail.f6dd2a4e.png";